import { EntityInEstateStatus } from '@/types/schema';

/**
 * Safely reads `stateInEstateStatus` off an entity subtype. The field is
 * present on most trust, personal, DAF, and private foundation subtypes
 * but not on the shared interfaces (e.g. `PersonalAccount`) or on some
 * other subtypes, so callers that work across the broad subtype union
 * need a runtime `in` check.
 */
export function pickStateInEstateStatus(
  subtype: unknown
): EntityInEstateStatus | null {
  if (
    subtype &&
    typeof subtype === 'object' &&
    'stateInEstateStatus' in subtype
  ) {
    const value = (
      subtype as { stateInEstateStatus?: EntityInEstateStatus | null }
    ).stateInEstateStatus;
    return value ?? null;
  }
  return null;
}
